import { ListRequestParams } from 'modules/domain/types'
import { endpoints } from 'modules/endpoints'
import { Dispatch, FC, SetStateAction } from 'react'
import { useParams } from 'react-router-dom'
import ATableFullPage from 'views/components/Table/ATableFullPage'
import useColumns from './useColumns'

type Props = {
  listRequestParams: ListRequestParams
  setListRequestParams: Dispatch<SetStateAction<ListRequestParams>>
  showBidMoveMovements: (sale_bid_id: number) => void
  isFiltersLoaded: boolean
}

export const MovementsGrouped: FC<Props> = ({
  isFiltersLoaded,
  setListRequestParams,
  listRequestParams,
  showBidMoveMovements,
}) => {
  const { id } = useParams()
  const columns = useColumns(showBidMoveMovements)

  return (
    <ATableFullPage
      listRequestParams={listRequestParams}
      listParamsUpdated={setListRequestParams}
      dataEndpoint={endpoints.warehouseSaleBids(id)}
      isFiltersLoaded={isFiltersLoaded}
      columns={columns}
      //nonClickableRow
    />
  )
}
